import { useState } from 'react';
import {
  StyledButtonGroup,
  DisabledWrapper,
  DisabledTooltipBubble,
} from './InputButtonGroup.styled';
import InputButton from '../InputButton';

const InputButtonGroup = ({
  options,
  value,
  onChange,
  width = '100%',
  buttonWidth = '48%',
  isDisabled = false,
  disabledReason,
}) => {
  const [hovered, setHovered] = useState(false);

  const group = (
    <StyledButtonGroup $width={width}>
      {options.map((option, index) => (
        <InputButton
          key={index}
          width={buttonWidth}
          selected={value === option}
          disabled={isDisabled}
          onClick={() => !isDisabled && onChange(option)}
        >
          {option}
        </InputButton>
      ))}
    </StyledButtonGroup>
  );

  if (isDisabled && disabledReason) {
    return (
      <DisabledWrapper
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {group}
        <DisabledTooltipBubble $show={hovered}>{disabledReason}</DisabledTooltipBubble>
      </DisabledWrapper>
    );
  }

  return group;
};

export default InputButtonGroup;
